import { Failure } from '@mrhenry/failure';

export type PersonalDetails = {
	readonly fullName: string;
	readonly fullNameFailure?: Failure;
	readonly email: string;
	readonly emailFailure?: Failure;
	readonly telephone: string;
	readonly telephoneFailure?: Failure;
	readonly feedback: string;
	readonly agreeToTerms: boolean;
	readonly agreeToTermsFailure?: Failure;
	readonly confirmRequest: boolean;
	readonly confirmRequestFailure?: Failure;
};

export type UpdatePersonalDetail = UpdateFullName | UpdateEmail | UpdateTelephone | UpdateFeedback | UpdateAgreeToTerms | UpdateConfirmRequest;

type UpdateFullName = {
	readonly type: 'UPDATE_FULL_NAME';
	readonly fullName: string;
	readonly fullNameFailure?: Failure;
};

type UpdateEmail = {
	readonly type: 'UPDATE_EMAIL';
	readonly email: string;
	readonly emailFailure?: Failure;
};

type UpdateTelephone = {
	readonly type: 'UPDATE_TELEPHONE';
	readonly telephone: string;
	readonly telephoneFailure?: Failure;
};

type UpdateFeedback = {
	readonly type: 'UPDATE_FEEDBACK';
	readonly feedback: string;
};

type UpdateAgreeToTerms = {
	readonly type: 'UPDATE_AGREE_TO_TERMS';
	readonly agreeToTerms: boolean;
	readonly agreeToTermsFailure?: Failure;
};

type UpdateConfirmRequest = {
	readonly type: 'UPDATE_CONFIRM_REQUEST';
	readonly confirmRequest: boolean;
	readonly confirmRequestFailure?: Failure;
};

export function checkIfPersonalDetailsValid( personalDetails: PersonalDetails ): boolean {
	if ( !personalDetails.fullName ) {
		return false;
	}

	if ( Failure.isFailure( personalDetails.fullNameFailure ) ) {
		return false;
	}

	if ( !personalDetails.email ) {
		return false;
	}

	if ( Failure.isFailure( personalDetails.emailFailure ) ) {
		return false;
	}

	if ( !personalDetails.telephone ) {
		return false;
	}

	if ( Failure.isFailure( personalDetails.telephoneFailure ) ) {
		return false;
	}

	if ( !personalDetails.agreeToTerms ) {
		return false;
	}

	if ( Failure.isFailure( personalDetails.agreeToTermsFailure ) ) {
		return false;
	}

	if ( !personalDetails.confirmRequest ) {
		return false;
	}

	if ( Failure.isFailure( personalDetails.confirmRequestFailure ) ) {
		return false;
	}

	return true;
}
